import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS,
} from '@modules/affiliate-program-subaffiliate-deals/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  IAffiliateProgramSubAffiliateDealsSavePayload,
  IAffiliateProgramSubAffiliateItemResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ITEM_QUERY_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_SAVE_MUTATION_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_SAVE_URL,
} from '../constants';

export default function useAffiliateProgramSubAffiliateDealEditMutation(): IContextMutationResult<
  void,
  Error,
  IAffiliateProgramSubAffiliateDealsSavePayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IAffiliateProgramSubAffiliateDealsSavePayload>({
    mutationKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_SAVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPut<void>(
      AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_SAVE_URL,
      { subaffiliate_condition: payload },
      {
        permission: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS.EDIT,
        urlParams: {
          id: payload.id || 0,
        },
      },
    ),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY] });

      if (variables.id) {
        queryClient.setQueryData<IAffiliateProgramSubAffiliateItemResponse>(
          [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ITEM_QUERY_KEY, variables.id],
          () => ({
            subaffiliate_condition: variables,
          }),
        );
      }

      displayPresetToast(variables.id ? 'edited' : 'created');
    },
  });
}
